// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../generated-types'

import gql from 'graphql-tag'
import { AttachmentsFragmentDoc } from './Attachments/Attachments.generated'
import { DescriptionFragmentDoc } from './Description/Description.generated'
import { FacilitiesFragmentDoc } from './FeatureLists/FacilityList/FacilityList.generated'
import { CapacitiesFragmentDoc } from './FeatureLists/CapacityList/CapacityList.generated'
export type SpaceDetailsFragment = {
  __typename?: 'Venue'
  description?: string | null
  documents?: Array<{
    __typename?: 'VenueDocument'
    name: string
    url: string
  }> | null
  spaceFeatures: Array<{
    __typename?: 'SpaceFeature'
    id?: number | null
    name?: string | null
  }>
  spatialConfigurations: Array<{
    __typename?: 'SpatialConfiguration'
    name?: string | null
    capacity?: number | null
  }>
}

export const SpaceDetailsFragmentDoc = gql`
  fragment SpaceDetails on Venue {
    ...Attachments
    ...Description
    ...Facilities
    ...Capacities
  }
  ${AttachmentsFragmentDoc}
  ${DescriptionFragmentDoc}
  ${FacilitiesFragmentDoc}
  ${CapacitiesFragmentDoc}
`
